import React, { Component } from 'react';

import ThumbnailCard from '../thumbnail-card/ThumbnailCard';
import EventUtils from '../../utils/EventUtils';

class ThumbnailsGrid extends Component {
    constructor(props) {
        super(props);

        this._handleScroll = this._handleScroll.bind(this);
    }

    _handleScroll(event) {
        let grid = document.querySelector('.thumbnail-grid');
        if (event.deltaY && event.deltaY < 0) {
            return;
        }

        if (Math.trunc(grid.scrollHeight - grid.clientHeight - grid.scrollTop) !== 0) {
            return;
        }
    
        EventUtils.raiseEvent('scroll-bottom', null, this.props);
    }

    render() {
        const { thumbnailMapper, entries, selected, hidden } = this.props;

        return (
            <div className="thumbnail-grid" hidden={ hidden || entries.length === 0 } onScroll={ this._handleScroll } onWheel={ this._handleScroll }>
                { 
                entries.map((entry, index) => {
                    let thumbnailData = thumbnailMapper(entry);
                    return (<ThumbnailCard key={index} id={ index }
                                href={ thumbnailData.href } 
                                thumbnail={ thumbnailData.thumbnail } 
                                text={ thumbnailData.text }
                                actions={ thumbnailData.actions }
                                data={ entry }
                                selected={ selected.includes(index) }
                                showSelectButton={ selected.length !== 0 }
                                onSelect={ this.props.onSelect } />);
                })
                }
            </div>
        ); 
    }
}

export default ThumbnailsGrid;